import { Footer } from '../../components';
import './ContentLayout.scss';

const ContentLayout = ({ children }) => {
  return (
    <div className="ContentLayout">
      { children }
      <Footer />
    </div>
  );
}

export default ContentLayout;